import { createStorefrontClient } from "@shopify/hydrogen-react";
export const shopifyProductMap = {
    og: "gid://shopify/ProductVariant/42524998992011",
    gr: "gid://shopify/ProductVariant/42525036904587",
    gv: "gid://shopify/ProductVariant/42524999090315",
    kb: "gid://shopify/ProductVariant/42524999188619",
    om: "gid://shopify/ProductVariant/42179480289419",
    lr: "gid://shopify/ProductVariant/42524999155851",
    lv: "gid://shopify/ProductVariant/42524999057547",
    ng: "gid://shopify/ProductVariant/42524999024779",
    nm: "gid://shopify/ProductVariant/42524998959243",
    nocreatinewatermelonpw: "gid://shopify/ProductVariant/42516337229963",
    nocreatinestrawberrypw: "gid://shopify/ProductVariant/42516337361035",
    decafwatermelonpw: "gid://shopify/ProductVariant/42516337197195",
    decafstrawberrypw: "gid://shopify/ProductVariant/42516337328267",
    histimwatermelonpw: "gid://shopify/ProductVariant/42516337098891",
    histimstrawberrypw: "gid://shopify/ProductVariant/42516337262731",
    lowstimwatermelonpw: "gid://shopify/ProductVariant/42516337164427",
    lowstimstrawberrypw: "gid://shopify/ProductVariant/42516337295499",
    // hydrations
    low_caff_mango: "gid://shopify/ProductVariant/42510248050827",
    low_nocaff_mango: "gid://shopify/ProductVariant/42510248116363",
    high_caff_mango: "gid://shopify/ProductVariant/42510248083595",
    high_nocaff_mango: "gid://shopify/ProductVariant/42510248149131",
    low_caff_lemonlime: "gid://shopify/ProductVariant/42510248181899",
    low_nocaff_lemonlime: "gid://shopify/ProductVariant/42510248247435",
    high_caff_lemonlime: "gid://shopify/ProductVariant/42510248214667",
    high_nocaff_lemonlime: "gid://shopify/ProductVariant/42510248280203",
    low_caff_strawberrylemonade: "gid://shopify/ProductVariant/42179479371915",
    low_nocaff_strawberrylemonade: "gid://shopify/ProductVariant/42510247985291",
    high_caff_strawberrylemonade: "gid://shopify/ProductVariant/42510247952523",
    high_nocaff_strawberrylemonade: "gid://shopify/ProductVariant/42510248018059",
    greens_tropicalpineapple_28: "gid://shopify/ProductVariant/42681027887243",
    greens_lemonginger_28: "gid://shopify/ProductVariant/42681028116619",
    creatine: "gid://shopify/ProductVariant/42179479273611",
    collagen: "gid://shopify/ProductVariant/42179479175307",
    fiber: "gid://shopify/ProductVariant/42179479109771",
    blenderbottle: "gid://shopify/ProductVariant/42617633800331",
    wb221: "gid://shopify/ProductVariant/42619457896587",
    wb222: "gid://shopify/ProductVariant/42619462156427",
    frother: "gid://shopify/ProductVariant/42678535454859",
};
export const shopifyProductIds = {
    protein: 7525299060875,
    hydration: 7340944425099,
    preworkout: 7340944523403,
    creatine: 7340944326795,
    collagen: 7340944261259,
    fiber: 7340944195723,
    greens: 7525287592075,
};
export const shopifyProductPlans = {
    protein: {
        3: 1573945483,
        4: 1573879947,
        6: 1572274315,
        8: 1571651723,
    },
    hydration: {
        3: 1568866443,
        4: 1568374923,
        6: 1570570379,
        8: 1573322891,
    },
    bundle: {
        3: 1509490827,
        4: 1492254859,
        6: 1492222091,
        8: 1492287627,
    },
    preworkout: {
        3: 1568440459,
        4: 1568669835,
        6: 1568931979,
        8: 1571946635,
    },
    greens: {
        3: 1572372619,
        4: 1572307083,
        6: 1573486731,
        8: 1572110475,
    },
    fiber: {
        3: 1567883403,
        4: 1567948939,
        6: 1568047243,
        8: 1567916171,
    },
    collagen: {
        3: 1568145547,
        4: 1568014475,
        6: 1569259659,
        8: 1568080011,
    },
    creatine: {
        3: 1574174859,
        4: 1574207627,
        6: 1568243851,
        8: 1568800907,
    },
};
export const shopifyFlavorBoostsMap = {
    variety: {
        product: "7490993062027",
        variant: "42579625738379",
        externalPlanId: {
            3: 1569423499,
            4: 1572569227,
            6: 1573552267,
            8: 1572601995,
        },
    },
    caramel: {
        product: "7490991915147",
        variant: "42579619348619",
        externalPlanId: {
            3: 1571487883,
            4: 1570799755,
            6: 1570406539,
            8: 1570832523,
        },
    },
    chocolate: {
        product: "7490985263243",
        variant: "42579582713995",
        externalPlanId: {
            3: 1573290123,
            4: 1568702603,
            6: 1569849483,
            8: 1568637067,
        },
    },
    cinnamon: {
        product: "7490990538891",
        variant: "42579611484299",
        externalPlanId: {
            3: 1571815563,
            4: 1570013323,
            6: 1572339851,
            8: 1572733067,
        },
    },
    cookies: {
        product: "7490986934411",
        variant: "42579588645003",
        externalPlanId: {
            3: 1570504843,
            4: 1570144395,
            6: 1571094667,
            8: 1571750027,
        },
    },
    mocha: {
        product: "7490989293707",
        variant: "42579601555595",
        externalPlanId: {
            3: 1569882251,
            4: 1570537611,
            6: 1569226891,
            8: 1572143243,
        },
    },
    peanut: {
        product: "7490987458699",
        variant: "42579592085643",
        externalPlanId: {
            3: 1569325195,
            4: 1569194123,
            6: 1573388427,
            8: 1571684491,
        },
    },
    strawberry: {
        product: "7490988671115",
        variant: "42579598278795",
        externalPlanId: {
            3: 1572044939,
            4: 1569095819,
            6: 1570078859,
            8: 1570865291,
        },
    },
    vanilla: {
        product: "7490987950219",
        variant: "42579595231371",
        externalPlanId: {
            3: 1568833675,
            4: 1568768139,
            6: 1572831371,
            8: 1570308235,
        },
    },
};
export const proteinMap = {
    og: {
        sku: "OG14",
        variant: "42524998992011",
        qtyVariants: {
            1: "42681096700043",
            2: "42681098469515",
            3: "42681098797195",
        },
    },
    lr: {
        sku: "LR14",
        variant: "42524999155851",
        qtyVariants: {
            1: "42681096929419",
            2: "42681098666123",
            3: "42681098993803",
        },
    },
    nm: {
        sku: "NM14",
        variant: "42524998959243",
        qtyVariants: {
            1: "42715076427915",
            2: "42715076460683",
            3: "42715076493451",
        },
    },
    om: {
        sku: "OM14",
        variant: "42524998959243",
        qtyVariants: {
            1: "42681096667275",
            2: "42681098436747",
            3: "42681098764427",
        },
    },
    ng: {
        sku: "NG14",
        variant: "42524999024779",
        qtyVariants: {
            1: "42681096732811",
            2: "42681098502283",
            3: "42681098829963",
        },
    },
    lv: {
        sku: "LV14",
        variant: "42524999057547",
        qtyVariants: {
            1: "42681096798347",
            2: "42681098567819",
            3: "42681098895499",
        },
    },
    gv: {
        sku: "GV14",
        variant: "42524999090315",
        qtyVariants: {
            1: "42681096896651",
            2: "42681098633355",
            3: "42681098961035",
        },
    },
    kb: {
        sku: "KB14",
        variant: "42524999188619",
        qtyVariants: {
            1: "42681096994955",
            2: "42681098731659",
            3: "42681099059339",
        },
    },
    gr: {
        sku: "GR14",
        variant: "42525036904587",
        qtyVariants: {
            1: "42681096962187",
            2: "42681098698891",
            3: "42681099026571",
        },
    },
};
// export const bundleQuantityToVariantMap = {
//   1: "42682214678667",
//   2: "42682214711435",
//   3: "42682214744203",
// };
export const STORE_DOMAIN = "https://gainfulnew.myshopify.com";
export const PUBLIC_STOREFRONT_TOKEN = "a5b0cd2f9a7274cc28b92d0b4eeda19b";
export const client = createStorefrontClient({
    // load environment variables according to your framework and runtime
    storeDomain: STORE_DOMAIN,
    publicStorefrontToken: PUBLIC_STOREFRONT_TOKEN,
});
export const fetchShopifyGraphQLData = async (query) => {
    const response = await fetch(client.getStorefrontApiUrl(), {
        body: JSON.stringify({
            query: query,
        }),
        // Generate the headers using the private token.
        headers: client.getPublicTokenHeaders(),
        method: "POST",
    });
    if (!response.ok) {
        throw new Error(response.statusText);
    }
    const json = await response.json();
    return json;
};
